var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-md-6",domProps:{"innerHTML":_vm._s(_vm.props.CAPTION)}}),_c('div',{staticClass:"col-md-6",domProps:{"innerHTML":_vm._s(_vm.props.VALUE)}})])}
var staticRenderFns = []

export { render, staticRenderFns }